export default {
	section_banner: {
		title: {
			one: '方法',
			two: '使用',
		},
		main_title: {
			one: '商人',
		},
		paragraph: {
			one: 'お客様ご自身で簡単にお支払いいただけます。ぜひお試しください。 ',
			two: '携帯電話で即時決済できるJPWorldPay ',
			three: '現金やカードは不要です。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Download App',
		},
	},

	section_we_offer_sec: {
		label: { one: 'ワンテザーウォレット' },
		title: {
			one: '支払いの使用',
			two: '方法',
		},
		paragraph: {
			one: 'JPWorldPayは、高速、安全、そして便利な暗号通貨取引のために設計された、信頼できる電子ウォレットです。オンラインでもオフラインでも、JPWorldPayを使えば、いつでもどこでもデジタル資産を簡単に管理・利用できます',
		},
		white_box_1st: {
			heading: 'JPWorldPay を選択します',
			paragraph: '携帯電話でJPWorldPayを選択するだけで簡単に使用できます。',
		},
		white_box_2nd: {
			heading: 'オフラインストアでの支払い',
			paragraph: 'ウォレットを選択し、オフライン ストア支払いを選択します。',
		},
		white_box_3rd: {
			heading: 'QRコードをスキャンする',
			paragraph: 'キオスクのQRコードをスキャンすれば支払いは完了です。',
		},
		cta_buttons: {
			one: '無料アカウントを作成する',
		},
		mobile: {
			heading: 'どこでもショッピングを楽しむ',
			subheading: 'JPWorldPayウォレットに保管された暗号通貨',
		},
	},

	future_currency_sec: {
		label: 'ワンテザーウォレット',
		heading: {
			one: 'へようこそ',
			two: '将来の通貨',
			three: 'システム',
		},
		future_box_1st: {
			heading: '安全な支払い',
			paragraph: 'JPWorldPay は、QR コード取引中にお客様の情報を開示しません',
		},
		future_box_2nd: {
			heading: 'どの会社でも',
			paragraph:
				'24 時間いつでもどこでも、オフラインの加盟店で即時安全にお支払いいただけます。',
		},
		future_box_3rd: {
			heading: 'タッチフリー',
			paragraph:
				'現金やクレジットカードを気にする必要はありません。アプリケーションを開いて支払います。',
		},
	},

	seller_access_sec: {
		label: '最速の支払いシステム',
		title: {
			one: '売り手はできる',
			two: 'アクセス',
			three: '簡単に',
		},
		paragraph:
			'JPWorldPayキオスクで販売商品を登録するだけです。登録が完了すると、支払いはJPWorldPayキオスクで直接処理されるため、取引がシンプルかつ効率的になります。この合理化されたプロセスにより、時間を節約し、顧客体験を向上させます。最小限の設定で、最大限の利便性を実現し、シームレスな販売をお楽しみください。',
		cta_buttons: {
			one: '始めましょう',
		},
	},
	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
